import { useState, useEffect, useCallback } from 'react';
// style
import style from './playground.module.css';
// components
import Card from './components/card/Card';

const Playgrounds = () => {
  const [data, setData] = useState([]);
  const [category, setCategory] = useState('Все');
  const [loading, setLoading] = useState(true); // Стейт для загрузки

  // Получение данных из API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch('/api/1');
        const result = await res.json();
        setData(result);
      } catch (error) {
        console.error('Ошибка загрузки данных:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Фильтрация данных по категории
  const filterData = useCallback(
    (category) => {
      setCategory(category);
    },
    [] // Эта функция не зависит от стейтов, поэтому можно оставить пустым массив зависимостей
  );

  // Применение фильтрации данных
  const typeFilter =
    category === 'Все' ? data : data.filter((card) => card.Type === category);

  return (
    <section className={style.section}>
      <div className="container">
        {/* Заголовок */}
        <div className={style.title}>
          <h2>
            Крутые <span>Площадки</span> по всему городу
          </h2>
          <span>
            Для Лазертага, Пейнтбола и Гидробола. <b>Выбери свою</b>.
          </span>
        </div>

        {/* Кнопки фильтра */}
        <div className={style.nav}>
          <div className={style.buttons}>
            {['Все', 'Открытая', 'Крытая'].map((type) => (
              <button
                key={type}
                onClick={() => filterData(type)}
                className={category === type ? style.active : ''}
              >
                {type}
              </button>
            ))}
          </div>
        </div>

        {/* Площадки */}
        <div className={style.playgronunds}>
          {loading ? (
            <div className={style.error}>
              <div className="loader"></div>
            </div>
          ) : (
            <div className={style.cards}>
              {typeFilter.length > 0 ? (
                typeFilter.map((item) => <Card item={item} key={item.id} />)
              ) : (
                <div className={style.noResults}>
                  Нет доступных площадок для выбранной категории.
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Playgrounds;
